<template>
    <BreadCrumb :items="breadcrumbItems" />
    <main id="main">
        <PrivacyPolicyForm/>
    </main>
</template>
<script>
import PrivacyPolicyForm from '@/components/customerService/PrivacyPolicyForm.vue';
import BreadCrumb from '../layout/navigation/BreadCrumb.vue';

export default {
    data() {
        return {
            breadcrumbItems: [
                { href: "/", text: "홈", isHome: true },
                { href: "#", text: "고객센터" },
            ],
        };
    },
    components: {
        PrivacyPolicyForm,
        BreadCrumb
    }
}
</script>
<style lang="">
    
</style>